module.exports = __webpack_public_path__ + "img/logo_white_no_bg.5c2287a1.png";